/*
    default prefix "LISTS"
*/
export const AT_LIST_ACTION_SET = 'LISTS_LIST_ACTION_SET';
export const AT_LISTS_UPDATE = 'LISTS_LISTS_UPDATE';
export const AT_SET = 'LISTS_SET';
export const AT_DELETE = 'LISTS_DELETE';
